import _deburr from 'lodash.deburr'
import _snakeCase from 'lodash.snakecase'

export const slugify = str => _snakeCase(_deburr(str))
